import { render } from "./CourseInvitationPopup.vue?vue&type=template&id=19234c81&scoped=true"
import script from "./CourseInvitationPopup.vue?vue&type=script&lang=js"
export * from "./CourseInvitationPopup.vue?vue&type=script&lang=js"

import "./CourseInvitationPopup.vue?vue&type=style&index=0&id=19234c81&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19234c81"]])

export default __exports__